import React from 'react';

const AppMain = ({ children }) => {
  return <main>{children}</main>;
};

export default AppMain;
